import { render, staticRenderFns } from "./MethodsList.vue?vue&type=template&id=cf0348f8&scoped=true&"
import script from "./MethodsList.vue?vue&type=script&lang=js&"
export * from "./MethodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0348f8",
  null
  
)

export default component.exports